var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSearch1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.246,
    height: 19.245,
    viewBox: "0 0 19.246 19.245",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_search",
    transform: "translate(0.125 0.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_10",
    "data-name": "Union 10",
    d: "M17.678,18.771,13.707,14.8A8.375,8.375,0,1,1,14.8,13.708l3.971,3.971a.772.772,0,0,1-1.092,1.093ZM1.544,8.367A6.821,6.821,0,1,0,8.365,1.546,6.829,6.829,0,0,0,1.544,8.367Z",
    transform: "translate(0 -0.002)",
    fill: "#1b283f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_10_-_Outline",
    "data-name": "Union 10 - Outline",
    d: "M18.223,19.122a.89.89,0,0,1-.634-.263L13.7,14.968A8.5,8.5,0,1,1,14.967,13.7l3.891,3.891a.9.9,0,0,1-.635,1.532Zm-4.508-4.491,4.051,4.052a.647.647,0,0,0,.915-.916L14.63,13.716l.073-.088A8.25,8.25,0,1,0,13.627,14.7Zm-5.35.683a6.946,6.946,0,1,1,6.946-6.946A6.954,6.954,0,0,1,8.365,15.313Zm0-13.642a6.7,6.7,0,1,0,6.7,6.7A6.7,6.7,0,0,0,8.365,1.671Z",
    transform: "translate(0 -0.002)",
    fill: "#f2f2f7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch1);
export default __webpack_public_path__ + "static/media/ic_search(1).c9617da125e75dcdd1c81969b2bef0bf.svg";
export { ForwardRef as ReactComponent };